module.exports = __webpack_public_path__ + "static/media/react.f0793d9f.svg";